const requestSheetAsJson = require('../requestSheetAsJson')

const { REPORT_HISTORY_SHEET } = require('../../../../functions/globalConstants')

const fetchReportHistory = async () =>
  requestSheetAsJson(REPORT_HISTORY_SHEET)

module.exports = fetchReportHistory
